<template>
  <div id="app" v-if="show">
    <!-- <button v-if="deferredPrompt" @click="promptInstall()">
    Add to home screen
  </button> -->
    <main>
      <router-view></router-view>
      <back-to-top bottom="90px" right="25px">
        <button type="button" class="btn btn-info btn-to-top">
          <i class="fa fa-chevron-up"></i>
        </button>
      </back-to-top>
    </main>
  </div>
</template>

<script >
import db from "./config/FirebaseInit";
import firebase from "firebase/app";
import firebasedb from "@firebase/database";
export default {
  name: "App",
  data() {
    return {
      show: false,
    };
  },
  created() {
  //   window.addEventListener('beforeunload', function (e) {
  //   e.preventDefault();
  //   e.returnValue = '';
  // });

  // window.addEventListener('focus', function () {
  //     if (document.hidden) {
  //         alert('Please use only one tab or window for this website.');
  //         window.close();
  //     }
  // });
    // const messaging = firebase.messaging();
    // messaging.requestPermission()
    // .then(() => {
    //   //console.log('Notification permission granted.')
    //   return messaging.getToken()
    // })
    // .then(token => {
    //   //console.log(token)
    //   this.saveToken(firebase.auth().currentUser, token)
    // })
    // .catch((err) => {
    //   // this.loading = false
    //   // this.fetched = true
    //   // console.log('Unable to get permission to notify.', err)
    // })

    // // Listen for token refresh
    // messaging.onTokenRefresh(() => {
    //   messaging.getToken()
    //   .then(refreshedToken => {
    //     //console.log('Token refreshed.');
    //     this.saveToken(firebase.auth().currentUser, refreshedToken)
    //   })
    //   .catch( err => {
    //     // this.loading = false
    //     // this.fetched = true
    //     //console.log(err, 'Unable to retrieve new token')
    //   })
    // })

    // //Receive Message
    // messaging.onMessage((payload) => {
    //   // console.log("Message received. ", payload);
    //   // console.log("Message1 received. ", payload.notification);
    //   this.open1(payload.notification.title, payload.notification.body)
    // })

    if (this.$route.params.storename != undefined) {
      try {
        firebase.app(this.$route.params.storename);
        this.$store.state.secondaryDatabase = firebase
          .app(this.$route.params.storename)
          .firestore();
        this.show = true;
        //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
      } catch (err) {
        db.collection("shops")
          .where("owner", "==", this.$route.params.storename)
          .onSnapshot((querySnapshot) => {
            var shops = [];
            querySnapshot.forEach((doc) => {
              const data = {
                id: doc.id,
                shoptype: doc.data().shoptype,
                visits: doc.data().visits,
                loc: doc.data().location,
                categories: doc.data().categories,
                plan: doc.data().plan,
                cat: doc.data().cat,
                details: doc.data().details,
                config: doc.data().config,
                noDB: doc.data().noDB
              };
              shops.push(data);
              // console.log('shops[0].config',shops[0].config)
              // console.log(shops[0].id)

              if (!shops[0].noDB) { // having own db
                var secondaryAppConfig = shops[0].config;
                var secondary = firebase.initializeApp(
                  secondaryAppConfig,
                  this.$route.params.storename
                );
                this.$store.state.secondaryDatabase = secondary.firestore();
                // this.$store.state.secondaryApp = this.$route.params.storename
                this.$store.state.secondaryDatabase.settings({
                  timestampsInSnapshots: true,
                });
                this.$store.state.secondaryDatabase
                  .enablePersistence({ synchronizeTabs: true })
                  .then(() => {
                    //console.log("Woohoo! Multi-Tab Persistence!");
                  });
              } else {
                this.$store.state.secondaryDatabase = db;
                this.$store.state.noDB = true;
              }
              this.show = true;
              //console.log('secondaryDB', this.$store.state.secondaryDatabase)
            });
          });
      }
    } else {
      this.show = true;
      //console.log('this.$route.params.storename',this.$route.params.storename)
    }
  },
  methods: {
    saveToken(user, token) {
      const currentTokens = user.fcmTokens || [];
      //console.log('currentTokens',currentTokens)
      // If token does not exist in firestore, update db
      if (!currentTokens[token]) {
        const userRef = db.collection("users").doc(user.uid);
        const tokens = [...currentTokens, token];
        //console.log('tokens',tokens)
        userRef.update({ fcmTokens: tokens });
      }
    },
    open1(title, msg) {
      this.$notify({
        title: title,
        message: msg,
        type: "info",
      });
    },
  },
};
</script>

<style scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
body {
  margin: 0;
}

#app {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  background-color: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue